import { FC, useLayoutEffect, useRef } from "react";
import { Link } from "react-router";

import LegitimateIcon from "@/assets/logos/LogoSymbol.svg?react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

import { CMSTabs } from "./cms-tabs";

type Props = {
  skuId: string;
};

export const CMSContent: FC<Props> = ({ skuId }) => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const handleWheel = (event: WheelEvent) => {
      const root = document.getElementById("root");
      const preview = document.getElementById("preview");
      const target = ref.current;

      // Only scroll if the event target is inside #root but not inside a popover
      const isNodeInRoot = root && root.contains(event.target as Node);
      const isNodeInPreview = preview && preview.contains(event.target as Node);

      if (target && isNodeInRoot && !isNodeInPreview) {
        target.scrollTop += event.deltaY;
        event.preventDefault();
      }
    };

    window.addEventListener("wheel", handleWheel, { passive: false });
    document.body.classList.add("overflow-hidden");
    document.documentElement.classList.add("overflow-hidden");

    return () => {
      window.removeEventListener("wheel", handleWheel);
      document.body.classList.remove("overflow-hidden");
      document.documentElement.classList.remove("overflow-hidden");
    };
  }, []);

  return (
    <div
      ref={ref}
      className="flex flex-col flex-1 border-r p-8 overflow-y-scroll"
    >
      <h3 className="text-lg font-medium mb-2">Content</h3>
      <Alert className="mb-6 bg-muted">
        <LegitimateIcon className="size-4" />
        <AlertTitle className="text-base">Legitimate</AlertTitle>
        <AlertDescription className="text-sm">
          <p>
            You've chosen to build your webpage using Legitimate. To change
            this, go{" "}
            <Link to={`/skus/${skuId}/webpage`} className="underline">
              back to the SKU page
            </Link>
            .
          </p>
        </AlertDescription>
      </Alert>
      <CMSTabs />
    </div>
  );
};
